import { Box, IconButton, MenuItem, Stack,Grid } from '@mui/material';
import { GridActionsCellItem, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { useStatePtr } from '@pure-ptr/react';
import React, { useCallback, useMemo,useEffect,useState } from 'react';
import Helmet from 'react-helmet';
import Footer from '../../../_metronic/layout/footer/Footer';
import { useFitHeight } from '../../../_metronic/layout/Layout';
import { Select, XClientDataGrid } from '../../common';
import { Portlet, PortletHeader } from '../../partials/content/Portlet';
import { dateEquators, StringEquators } from '../../store/constants/pages';
import { createStringDataField, createStringFieldFromArray, createTimestampField } from '../../util/format';
import { ContractsBreadCrumb } from './ContractsBreadCrumb';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { ContractInfo } from '../../store/api/ai-api';
import PageviewIcon from '@mui/icons-material/Pageview';
import { useData } from '@pure-ptr/react'; // or your project's useData import
import { useHistory, useLocation } from "react-router-dom";
import { tiny } from '../../store/actions/contracts';
import { useDispatch,useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';
import { DeleteConfirmation} from '../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog';
import { errorToastify } from '../../util/toast';
import { ChatSidebarWrapper } from './ChatSidebarWrapper';
export const ContractAIChatHistory = ({ match : { params : { contractId,directoryId }, }}) => {
const ContractsApi=new ContractInfo()
useFitHeight();
   const history= useHistory()
   const dispatch=useDispatch()
   const [confirmDialogData, setConfirmDialogData] = useState({ open: false, rowData: null });
   const [deleteId, setDeleteId] = useState(null);

   const { search } = useLocation();
   const queryParams = useMemo(() => new URLSearchParams(search), [search]);
   const claimNumber = queryParams.get("claimNumber");
   const CHAT_TYPE = useMemo(() => (claimNumber ? "claim" : "contract"), [claimNumber]);

     /** Fetch chat sessions */
    const { data: chats, isPending, reload } = useData(
        async () => {
            const id = CHAT_TYPE === "claim" ? contractId : contractId;
            if (!id) return;
            return await ContractsApi.getAllChatSessions(id,CHAT_TYPE);
        },
        [contractId, CHAT_TYPE, claimNumber]
    );

        /** Delete session */
    const { data: deleteResponse, isPending: isDeleting, error } = useData(
        async () => {
            if (!deleteId) return;
            await ContractsApi.deleteChatSession(deleteId);
            setDeleteId(null);
            reload();
            setConfirmDialogData({ open: false, rowData: null });
        },
        [deleteId, CHAT_TYPE]
    );


    const tinyContracts:any = useSelector<RootState>( x => x?.contracts?.tiny );
    useEffect(() => {
      dispatch(tiny());
    }, []);

    // Sidebar state management
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(false);
    const [sidebarData, setSidebarData] = useState<{
        contractId: number;
        sessionId: number;
        directoryId: string;
        selected?: any[];
    } | null>(null);
    const fields = useMemo(() => {
        if(!CHAT_TYPE) return [];
        if (CHAT_TYPE === "claim") {
            return [
                createStringDataField('serial', 'S.No', {
                    sortable: false,
                    width: 60,
                    equators: StringEquators,
                }),
                createStringDataField('title', 'Title', { sortable: true, equators: StringEquators }),
                createTimestampField('createdAt', 'Created At', { sortable: true, equators: dateEquators }),
                createStringDataField('createdBy', 'Created By', { sortable: true, equators: StringEquators })
            ];
        } else {
            return [
                createStringFieldFromArray(
                    'contractIds',
                    'Contracts',
                    {
                        sortable: true,
                        equators: StringEquators,
                        renderCell: (params) => {
                            const contractIds = params.row?.contractIds || [];
                            const contractNames = contractIds
                                .map((id) => tinyContracts?.find((item) => item?.id == id)?.name)
                                .filter(Boolean)
                                .join(', ');
                            return contractNames || '-';
                        },
                    }
                ),
                createStringDataField('title', 'Title', { sortable: true, equators: StringEquators }),
                createTimestampField('createdAt', 'Created At', { sortable: true, equators: dateEquators }),
                createStringDataField('createdBy', 'Created By', { sortable: true, equators: StringEquators })
            ];
        }
    }, [tinyContracts, CHAT_TYPE]);


    const actions = useCallback( (params) => [
        <GridActionsCellItem
            icon={
                <IconButton size='small'>
                    <PageviewIcon />
                </IconButton>
            }
            label="View"
            onClick={() => {
                setSidebarData({
                    contractId: CHAT_TYPE === 'claim' ? contractId : contractId,
                    sessionId: params?.id,
                    directoryId: directoryId
                });
                setSidebarOpen(true);
            }}
        />,
          <GridActionsCellItem
            icon={<IconButton size='small'>
                <DeleteIcon />
                </IconButton>
            }
            label="Delete"
            onClick={() => setConfirmDialogData({open:true,rowData:params?.row})}
        />
    ], [CHAT_TYPE, contractId, directoryId]);
    const sortPtr = useStatePtr( [{ id: 'createdAt', direction: 'desc' }] );
    const contractPtr = useStatePtr<string>( 'all' ),
        contracts = useMemo(() => [
            { id: 'Cigna Commercial', label: 'Cigna Commercial', count: 1 },
            { id: 'Humana PPO', label: 'Humana PPO', count: 2 },
            { id: 'Aetna PPO', label: 'Aetna PPO', count: 3 },
        ], []);
        useEffect(() => {
            if (!error) return;
            errorToastify(
                error?.payload?.error || "Something Went Wrong !!!"
            );
        }, [error]);
    return <>
    {CHAT_TYPE === "contract" && <ContractsBreadCrumb root="/cms/contracts" directoryId={directoryId} />}
            <DeleteConfirmation
                DELETE_TEXT={`Are you sure you want to delete this chat?`}
                defaultSelected={[]}
                handleDelete={() => setDeleteId(confirmDialogData?.rowData?.id)}
                isDeleting={isDeleting!=null}
                defaultDeleteState={confirmDialogData}
                handleClose={() =>
                    setConfirmDialogData({ open: false, rowData: null })
                }
            />
            <Helmet title="Contracts" />
        
        {/* Main content wrapper with sidebar */}
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'row', 
            width: '100%', 
            height: sidebarOpen ? 'calc(100vh - 180px)' : 'auto',
            alignItems: 'flex-start',
            gap: 0,
            overflow: sidebarOpen ? 'hidden' : 'visible',
        }}>
            {/* Main content area */}
            <Box sx={{ 
                flex: sidebarExpanded ? 0 : 1,
                minWidth: 0,
                height: sidebarOpen ? '100%' : 'auto',
                opacity: sidebarExpanded ? 0 : 1,
                width: sidebarExpanded ? 0 : 'auto',
                overflow: sidebarExpanded ? 'hidden' : (sidebarOpen ? 'auto' : 'visible'),
                transition: 'all 0.3s ease-in-out',
            }}>
                <Portlet>
                    <PortletHeader
                        title="Contracts"
                        toolbar={<div />}
                    />
                    <Stack spacing={2} direction="column" sx={{ height: '100%', minHeight: 280 }}>
                        <XClientDataGrid
                            density='standard'
                            fields={fields}
                            actions={actions}
                            data={ chats || [] }
                            loading={ isPending!=null }
                            sortPtr={ sortPtr }
                            slots={{
                                toolbar: Toolbar as any
                            }}
                            slotProps={{
                                footer: {  } as any,
                                toolbar: {
                                    contracts,
                                    reload,
                                    contractPtr
                                } as any
                            }}
                        />
                    </Stack>
                </Portlet>
            </Box>

            {/* Chat Sidebar */}
            {sidebarOpen && sidebarData && (
                <ChatSidebarWrapper 
                    open={sidebarOpen}
                    onClose={() => {
                        setSidebarOpen(false);
                        setSidebarExpanded(false);
                        setSidebarData(null);
                    }}
                    contractId={sidebarData.contractId}
                    sessionId={sidebarData.sessionId}
                    directoryId={sidebarData.directoryId}
                    selected={sidebarData.selected || []}
                    chatType={CHAT_TYPE}
                    isExpanded={sidebarExpanded}
                    onExpandToggle={() => setSidebarExpanded(prev => !prev)}
                />
            )}
        </Box>
    </>
}
const Toolbar = ({ reload, contracts, contractPtr }) =>
    <GridToolbarContainer>
        <IconButton
            onClick={reload}
        >
            <RefreshIcon />
        </IconButton>
        {/*<Select
            label="Refresh Schedule Interval"
            valuePtr={contractPtr}
        >
            <MenuItem value='all'>All</MenuItem>
            { contracts.map( x =>
                <MenuItem key={x.id} value={x.id}>{x.label} ({x.count})</MenuItem>
            )}
        </Select>*/}
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
    </GridToolbarContainer>